import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APAdvisorText } from './../../servants/ap_advisor_text_servant';

export interface ICourse {
  title: string;
  rank: number;
  id: number;
  slotId: number;
  credits: number;
  course_id?: number;
  status: string;
}
class CourseTileMmComponentController {
  private isEditable: boolean | string;
  private isFromTerm: boolean | string;
  private buttonText: string = 'Plan';
  private isPlaceholderCourse: boolean | string = false;
  private isPlannedCourseWithSlots: boolean | string = false;
  private course: ICourse;
  private statePrefix: string;
  private isPast: boolean = false;
  private advisorLabel: string;
  private showMenu: string | boolean;
  private courseId: number = INVALID_ID;
  private showCourseDetailsMenu: boolean;
  private courseGroupId = INVALID_ID;
  private termId = INVALID_ID;
  private planningNotificationName = 'planorswapcourse';
  constructor(
    private $state: ng.ui.IStateService,
    private phxFeatureConfiguration: any,
    private ngAPAdvisorText: APAdvisorText,
    private phxFocusDelegate: any,
    private removeMmCourseGroupFromTermCommand: ICommand,
    private saveMmCourseToTermCommand: ICommand,
    private ngAPNotificationDelegate: INotificationDelegate,
    private loadMmAcademicPlanCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand,
    private routerHelper: RouterHelper
  ) {}

  initialize() {
    this.statePrefix = this.$state.includes('ap-advisor') ? 'ap-advisor' : 'my';
    this.advisorLabel = this.ngAPAdvisorText.advisorLabel;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.isFromTerm = _4.isBoolean(this.isFromTerm) ? this.isFromTerm : this.isFromTerm === 'true';
    this.isPlaceholderCourse = _4.isBoolean(this.isPlaceholderCourse)
      ? this.isPlaceholderCourse
      : this.isPlaceholderCourse === 'true';
    this.isPlannedCourseWithSlots = _4.isBoolean(this.isPlannedCourseWithSlots)
      ? this.isPlannedCourseWithSlots
      : this.isPlannedCourseWithSlots === 'true';
    if (this.isPlaceholderCourse || this.isPlannedCourseWithSlots) {
      this.showMenu = false;
      this.buttonText = this.getButtonText();
    } else {
      this.showMenu = this.isEditable;
    }
  }

  showNotification(content: string) {
    this.ngAPNotificationDelegate.info({
      content: `<div l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm"></hi-indicator>${content} </div>`,
      name: this.planningNotificationName
    });
  }

  hideNotification() {
    this.ngAPNotificationDelegate.dismissAlertByName(this.planningNotificationName);
  }

  getButtonText() {
    if (this.isPlannedCourseWithSlots) {
      return this.courseId === this.course.id ? 'Un plan' : 'Swap';
    }
    return 'Plan';
  }
  $onInit() {
    this.initialize();
  }

  getPayload() {
    return {
      term: this.termId,
      program_slot: this.course.slotId,
      course: this.course.id
    };
  }

  showCourseDetails() {
    if (this._isFromTerm) {
      this.showCourseDetailsMenu = !(this.isPlaceholderCourse || this.isPlannedCourseWithSlots);
    } else {
      this.showCourseDetailsMenu = this.courseGroupId < 0;
    }
    const _courseNk = _4.get(this.course, 'nk', INVALID_ID);
    const _courseDetailParams = {
      courseNk: _courseNk,
      courseId: this._courseId,
      plannedCourseId: this._plannedCourseId,
      termId: this.termId,
      slotId: this.course.slotId,
      showCourseDetailsMenu: this.showCourseDetailsMenu,
      isPast: this.isPast,
      status: this.course.status
    };
    this.routerHelper.findStateAndGo('.course_details', { courseDetailsParams: _courseDetailParams });
  }

  get _courseId() {
    return this._isFromTerm ? this.course.course_id || INVALID_ID : this.course.id;
  }
  get _plannedCourseId() {
    return this._isFromTerm ? this.course.id || INVALID_ID : INVALID_ID;
  }

  get _isFromTerm() {
    return _4.gt(this.termId, 0);
  }

  unplanOrSwapCourse() {
    const payload = this.getPayload();
    if (this.isPlannedCourseWithSlots) {
      this.courseId === this.course.id ? this.unPlanCourse() : this.swapCourse(payload);
    } else {
      // remove coursegrooup(placeholder) from term and add selected course to term.
      this.removeCourseGroupAndAddCourseToTerm(payload);
    }
  }

  async removeCourseGroupAndAddCourseToTerm(payload: { term: number; program_slot: number; course: number }) {
    try {
      const studentId = await this.removeMmCourseGroupFromTermCommand(this.courseGroupId);
      this.showNotification(`Adding a course ${this.course.title} to term.`);
      await this.saveMmCourseToTermCommand(payload);
      this.hideNotification();
      this.showNotification(`Reloading terms data`);
      await this.loadMmAcademicPlanCommand(studentId);
      this.hideNotification();
    } catch {
      this.hideNotification();
    }
  }

  unPlanCourse() {
    this.removeMmCourseFromTermCommand(this.courseGroupId).then((studentId: number) => {
      this.loadMmAcademicPlanCommand(studentId);
    });
  }
  async swapCourse(payload: { term: number; program_slot: number; course: number }) {
    try {
      this.showNotification('Swapping a course...');
      const studentId = await this.removeMmCourseFromTermCommand(this.courseGroupId);
      this.hideNotification();
      this.showNotification(`Adding a course ${this.course.title} to term.`);
      await this.saveMmCourseToTermCommand(payload);
      this.hideNotification();
      this.showNotification(`Reloading terms data`);
      await this.loadMmAcademicPlanCommand(studentId);
      this.hideNotification();
    } catch {
      this.hideNotification();
    }
  }

  $onChanges() {
    this.initialize();
  }
}

class CourseTileMmComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      course: '<',
      isFromTerm: '<',
      isPlaceholderCourse: '<',
      isPlannedCourseWithSlots: '<',
      courseId: '<',
      isPast: '<?',
      isEditable: '<',
      courseGroupId: '<?',
      termId: '<?'
    };
    this.controller = CourseTileMmComponentController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_tile_component/course_tile_mm_component.html';
  }
}

angular.module('capability-ng-academic-planner').component('courseTileMmComponent', new CourseTileMmComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_tile_component/course_tile_mm_component.ts